import { server } from '../constants';
import { httpClient } from '../utils/HttpClient';

/*________________
 *  Observer Data
 *================
 */

/**
 * addObserver()
 * @returns
 * Detail: add new observer
 * Method: POST
 * API Doc: /muit-iDev/pdpa-im-api/-/wikis/Transaction/Observer#remove-observer
 */
export function addObserver({ issue_id = null, user_id = null }) {
  return httpClient
    .post(`${server.OBSERVER_URL}/add`, { issue_id, user_id })
    .then((result) => {
      return result.data.content;
    })
    .catch((error) => {
      throw error;
    });
}

/**
 * removeObserver()
 * @returns
 * Detail: remove observer
 * Method: DELETE
 * API Doc: /muit-iDev/pdpa-im-api/-/wikis/Transaction/Observer#remove-observer
 * axios deleting body: https://stackoverflow.com/questions/51069552/axios-delete-request-with-body-and-headers
 */
export function removeObserver(data = { issue_id: null, user_id: null }) {
  return httpClient
    .delete(`${server.OBSERVER_URL}/remove`, { data })
    .then((result) => {
      return result.data.content;
    })
    .catch((error) => {
      throw error;
    });
}
